import React, {useCallback, useRef, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import TopDestinationsUI from '../../../../stories/components/hotels/HomePage/TopDestinationsUI/TopDestinationsUI';
import SegmentSliderLoader from '../../../../stories/components/hotels/HomePage/SegmentSlider/SegmentSliderLoader/SegmentSliderLoader';
import useIntersectionObserver from '../../../hooks/useIntersectionObserver';
import {destinationsSelectorFn} from '../destinations-redux/selectors';
import {fetchDestinationsThunk} from '../destinations-redux/thunks';
import {eventMiddlewareForFE} from '../../../utils/common-utils';
import {pushga} from 'ga-utils';
import {HomePageGAEvents} from '../../../config/ga-config';

const intersectionObserverOptions = {
  root: null,
  threshHold: 0.01,
};

const TopDestinations = () => {
  const dispatch = useDispatch();
  const {data: topDestinationsDataFromState, isLoading: isTopDestinationsLoading} = useSelector(
    destinationsSelectorFn,
  );

  const topDestinationsDataFromStateRef = useRef(topDestinationsDataFromState);

  const fetchTopDestinationsThunkCaller = useCallback(() => {
    return dispatch(fetchDestinationsThunk());
  }, [dispatch]);

  const [watcherRef] = useIntersectionObserver(intersectionObserverOptions, () => {
    if (!topDestinationsDataFromStateRef.current) {
      fetchTopDestinationsThunkCaller();
    }
  });

  useEffect(() => {
    topDestinationsDataFromStateRef.current = topDestinationsDataFromState;
  }, [topDestinationsDataFromState]);

  if (isTopDestinationsLoading) return <SegmentSliderLoader />;

  let tagsList = [];

  if (topDestinationsDataFromState) {
    const {meta_config, tags_data, popular_tags} = topDestinationsDataFromState;
    const {entities_data} = meta_config;
    const {tags} = tags_data;
    const tagsObj = {...tags};

    let tagsListTemp = {};

    popular_tags.map(item => {
      tagsListTemp[item] = {
        id: item,
        name: tagsObj[item]?.n,
        cityList: [],
      };
    });

    Object.keys(entities_data).map(entitiesKey => {
      entities_data[entitiesKey].tags.map(tagId => {
        if (tagsListTemp[tagId]) {
          tagsListTemp[tagId].cityList.push(entities_data[entitiesKey]);
        }
      });
    });

    // const cityList = trending_destinations.id_list.map(cityId => entities_data[cityId]);

    // cityList.map(cityItem => {
    //   cityItem.tags.map(cityTagItem => {
    //     if (
    //       tagsObj[cityTagItem].cityList &&
    //       !tagsObj[cityTagItem].cityList.find(tagsCityItem => cityItem.lid === tagsCityItem.lid)
    //     ) {
    //       tagsObj[cityTagItem].cityList.push(cityItem);
    //     } else {
    //       tagsObj[cityTagItem].cityList = [cityItem];
    //     }
    //   });
    // });

    // tagsList = Object.keys(tagsObj)

    tagsList = Object.keys(tagsListTemp)
      .map(tagKey => tagsListTemp[tagKey])
      .filter(item => item.cityList && item.cityList.length > 0);
  }

  const sliderClicksGAHandler = index => {
    pushga({
      eventCategory: HomePageGAEvents.sliderClicks.category,
      eventAction: HomePageGAEvents.sliderClicks.action.offerSliderClicked,
      eventLabel: index,
    });
  };

  return (
    <div ref={watcherRef}>
      {(topDestinationsDataFromState && (
        <TopDestinationsUI
          data={tagsList}
          eventMiddlewareForFE={eventMiddlewareForFE}
          sliderClicksGAHandler={sliderClicksGAHandler}
        />
      )) || <SegmentSliderLoader />}
    </div>
  );
};

export default TopDestinations;
